import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteEventExpenseService } from '@/services/events'
import { eventDetailsQueryKey } from './useEventDetails'

export const useDeleteEventExpense = (agendaId: string, eventId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (expenseId: number) => deleteEventExpenseService(agendaId, eventId, expenseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: eventDetailsQueryKey(agendaId, eventId) })
    },
  })
}
